<template>
  <div>
    <b-navbar toggleable="lg" class="nav-backgound">
      <div class="container">
        <b-navbar-brand href="#">
          <img src="@/assets/Logo_APIS.png" alt />
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav>
              <b-nav-item href="#Us">Empresa</b-nav-item>
              <b-nav-item href="#Projects">Proyectos</b-nav-item>
              <b-nav-item href="#Contact">Contactanos</b-nav-item>
            </b-navbar-nav>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <apis-hero />
    <apis-content1 />
    <!-- <slider /> -->
    <slider-big />
    <apis-values id="Us" />
    <apis-projects id="Projects" />
    <apis-contact-us id="Contact" />
    <apis-footer />
  </div>
</template>

<script>
import ApisHero from "../components/ApisHero";
import ApisContent1 from "../components/ApisContent1";
import ApisValues from "../components/ApisValues";
import ApisProjects from "../components/ApisProjects";
import ApisContactUs from "../components/ApisContactUs";
import SliderBig from "../components/SliderBig";
import ApisFooter from "../components/ApisFooter";

export default {
  name: "Home",
  components: {
    ApisHero,
    ApisContent1,
    ApisValues,
    ApisProjects,
    ApisContactUs,
    SliderBig,
    ApisFooter,
  },
};
</script>
<style scoped>
.nav-backgound,
#Us,
#Projects,
#Contact {
  background-color: #ebf5ee;
}
img {
  height: 50px;
}
#Contact {
  height: 400px;
}
@media screen and (min-width: 768px) {
  #Contact {
    height: auto;
  }
}
</style>
